import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import FooterItem from '../../components/FooterItem';
import { getAuthInfo} from '../../api/mockData';
import {Avatar, Flex,Button,Divider,Descriptions,Tag} from 'antd'
import {UserOutlined, MailFilled} from '@ant-design/icons'
import './style.css'
import SnakeGame from './game';
import { DoubleLeftOutlined} from '@ant-design/icons';
const About = function () {
    const navigate = useNavigate();
    const [userInfo, setUserInfo] = useState(getAuthInfo());
    return (
        <div>
            <div className = "about-header">
              <h1 style = {{color: 'white', fontSize: '2rem' ,fontWeight: 'bold'}}>关于作者</h1>
              <Button className = "back-button"
               icon = { <DoubleLeftOutlined />}
               onClick = {() => navigate(-1)}
               >

               </Button>
            </div>
            <div className="auth-container">
              <Flex vertical> 
                <Flex vertical = {false} gap = "small">
                  <div className = "auth-left-container">
                    {/* avatar */}
                     {userInfo?.getAvatar() ? (
                     <Avatar src={userInfo.getAvatar() } size = {196}/>
                    ) : (
                     <Avatar icon={<UserOutlined />} size = {196} />
                    )}  
                    {/* info */}
                    <h1>{userInfo?.getName() || 'User'}</h1>
                    <Divider style={{ borderColor: '#aaa' }}></Divider>
                    <p>{userInfo?.getIntrocution() || 'No Introcution'}</p>
                    <p>{userInfo?.getDetails() || 'No Detail'}</p>
                    <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <MailFilled />
                      <span>{userInfo?.getEmail() || 'No Email'}</span>
                    </span>
                    
                  </div>
                  <div className = "auth-right-container">
                    <Descriptions title="其他信息" bordered column={1} className = "auth-descriptions">
                      <Descriptions.Item label="兴趣爱好" className = "auth-descriptions-item">{userInfo?.getInterest() || 'User'}</Descriptions.Item>
                      <Descriptions.Item label="技术栈" className = "auth-descriptions-item">
                        <Flex gap = "small">
                          {userInfo?.getTechStack().map(tech => <Tag color = "blue">{tech}</Tag>) || 'No TechStack'}
                        </Flex>
                      </Descriptions.Item>
                     
                    </Descriptions>
                    <SnakeGame rows={30} cols={100} />
                  </div>
                </Flex>
              </Flex>
              
            </div>
            <FooterItem/>
        </div>
    )
}
export default About;